import AddSearchNewMemberBtnPresenter from "./AddSearchNewMemberBtnPresenter";

export const AddSearchNewMemberBtn = AddSearchNewMemberBtnPresenter;

export default AddSearchNewMemberBtn;

